import Card from '../../../layout/Card';
import Master from '../../../layout/Master';
import Sidbar from '../../../layout/Sidbar';
import BCButom from '../../../Tools/BCButom';
import './style.css';
// const  = () => {
   
// }
function EmptyPge() {
    return(
        <>
            <div className='mainErroe' dir='rtl'>
                <h2>این صفحه درحال طراحی میباشد...</h2>
                <img src='/image/kindpng_1512076.png'/>
                <div className='divBtn'>
                <a href='/'> <BCButom className='btnTow' > «  بازگشت به خانه </BCButom></a>
                </div>
            </div>
            

        </>
    )
}
export default EmptyPge;